import { faker } from '@faker-js/faker/locale/ja';
import { ApReportStatus } from 'ap-openapi';
import { HttpResponse, delay, http } from 'msw';
import { FIXED_REF_DATE } from '../../constants';

faker.seed();
// const reportFormType = {
//   ApReportFormInputCheckBox: 'ApReportFormInputCheckBox',
//   ApReportFormInputInvoiceInstantPayee: 'ApReportFormInputInvoiceInstantPayee',
//   ApReportFormInputReportNumberForExpenseField:
//     'ApReportFormInputReportNumberForExpenseField',
//   ApReportFormInputContractNumberField: 'ApReportFormInputContractNumberField',
//   ApReportFormInputInvoiceRegistrationNumberField:
//     'ApReportFormInputInvoiceRegistrationNumberField',
//   ApReportFormInputSelect: 'ApReportFormInputSelect',
//   ApReportFormInputDateField: 'ApReportFormInputDateField',
//   ApReportFormInputNumberField: 'ApReportFormInputNumberField',
//   ApReportFormInputSpecialExceptionStatusSelect:
//     'ApReportFormInputSpecialExceptionStatusSelect',
//   ReportFormStatusContainer: 'ReportFormStatusContainer',
//   ApReportFormInputDeptSelect: 'ApReportFormInputDeptSelect',
//   ApReportFormInputNumberFieldForBranch:
//     'ApReportFormInputNumberFieldForBranch',
//   ApReportFormInputTextArea: 'ApReportFormInputTextArea',
//   ApReportFormInputExItemSelect: 'ApReportFormInputExItemSelect',
//   ApReportFormInputPayeeSelect: 'ApReportFormInputPayeeSelect',
//   ApReportFormInputTextField: 'ApReportFormInputTextField',
//   ApReportFormInputFileField: 'ApReportFormInputFileField',
//   ApReportFormInputProjectSelect: 'ApReportFormInputProjectSelect',
//   ApReportFormInputTimeField: 'ApReportFormInputTimeField',
//   ApReportFormInputInvoiceBookDateField:
//     'ApReportFormInputInvoiceBookDateField',
//   ApReportFormInputRadioButton: 'ApReportFormInputRadioButton',
//   ApReportFormInputInvoiceDueDateField: 'ApReportFormInputInvoiceDueDateField',
//   ApReportFormInputReceiptType: 'ApReportFormInputReceiptType',
// };

// const reportFormInputsData = [
//   {
//     annotation: ['test', 'test1'],
//     default_value: ['test'],
//     has_other_value: false,
//     id: faker.word.sample(),
//     input_options: getGetApPayees(1),
//     input_values: undefined,
//     is_editable: faker.datatype.boolean(), // for setting, it is unused at edit page
//     is_hidden: faker.datatype.boolean(), // for setting, it is unused at edit page
//     is_required: true,
//     label: '支払先',
//     priority: faker.number.int({ min: undefined, max: undefined }),
//     type: reportFormType.ApReportFormInputPayeeSelect,
//   },
// ];

export const getGetInvoiceReportsMock = () => ({
  id: 'M9X9hw-4lnmdpOhMJPGn_g',
  title: '2024年10月支払依頼',
  report_dept: {
    dept_and_position_name: '部門なし',
    fixed_dept_and_position_name: '部門なし',
    initial_selected_id: '0',
    is_changeable: true,
    is_viewable: true,
  },
  status: 'unsubmitted',
  number: 'AP1138',
  number_without_prefix: 1138,
  submitted_at: null,
  approved_at: null,
  created_at: '2024-10-28T18:51:37+09:00',
  updated_at: '2024-11-08T19:46:39+09:00',
  flash_messages: [],
  report_type: {
    id: '051Dq7-RWhIVs_J9bz2LzA',
    name: '支払依頼',
  },
  report_form_inputs: [
    {
      id: '8WxGG2OVVPztq9cx2RTmag',
      label: '支払先種別',
      type: 'ApReportFormInputInvoicePayeeType',
      priority: 0,
      is_required: true,
      is_hidden: false,
      is_editable: false,
      has_other_value: false,
      default_value: '1005',
      annotation: '',
      input_options: [
        {
          id: 'LhmqtGuYLBR_m2jWnlaisg',
          ap_report_form_input_option_master_id: 1005,
          value: '登録済みの支払先',
          display_value: '登録済みの支払先',
          priority: 1,
        },
        {
          id: 'MslzAzJ1-FPqru_foi2Q6A',
          ap_report_form_input_option_master_id: 1006,
          value: 'スポット支払（未登録の支払先）',
          display_value: 'スポット支払（未登録の支払先）',
          priority: 2,
        },
      ],
      input_values: [
        {
          id: '2AVRqUi1qzcK-QudXDxBdg',
          value: '1005',
        },
      ],
      input_additional_values: null,
    },
    {
      id: '9vcyxeq0tB20bQFYcoaraw',
      label: '支払先',
      type: 'ApReportFormInputInvoicePayeeSelect',
      priority: 1,
      is_required: true,
      is_hidden: false,
      is_editable: false,
      has_other_value: false,
      default_value: null,
      annotation: '支払先が無い場合は管理者に登録を依頼してください',
      input_options: null,
      input_values: [
        {
          id: 'xRCMFchmk6xj0ClVM6mdpg',
          value: 'aCkOVet_cb2z-uLXgVQ0YQ',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'o6vpshKaWxSRSoo-L_2Qcw',
      label: '支払先(スポット支払)',
      type: 'ApReportFormInputInvoiceInstantPayee',
      priority: 2,
      is_required: true,
      is_hidden: false,
      is_editable: false,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: null,
      input_additional_values: null,
    },
    {
      id: 'JR8vsZGAYeOLufXBiqjPxg',
      label: '特例区分',
      type: 'ApReportFormInputSpecialExceptionStatus',
      priority: 3,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: '',
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: '23iLnaVz7Ly4vPZZluHBhA',
          value: '0',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'JomjIKEPZMvTLJ78PxvmZA',
      label: '適格請求書発行事業者登録番号',
      type: 'ApReportFormInputInvoiceRegistrationNumberField',
      priority: 4,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: '',
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: 'QNSLieiIGl5NQQsXjd0z5A',
          value: '',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'p67_FhRVTzphnfBVUYBeWA',
      label: '請求書画像',
      type: 'ApReportFormInputInvoiceFileField',
      priority: 5,
      is_required: false,
      is_hidden: false,
      is_editable: false,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: 'C3FjO9L_kCENSm7vGCfpPg',
          value: 'prEqTv8Obt9YRNG7oCGtfw',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'bQS7rRgT6xc8K53bexhJXg',
      label: '請求書の受領区分',
      type: 'ApReportFormInputReceiptType',
      priority: 6,
      is_required: false,
      is_hidden: false,
      is_editable: false,
      has_other_value: false,
      default_value: '',
      annotation: '請求書画像が添付された時のみ、必須項目になります',
      input_options: [
        {
          id: 'yAsHYR97lSzYEJdRgenShg',
          ap_report_form_input_option_master_id: 1003,
          value: '1003',
          display_value: '電子 (PDF,JPEG等) で受領した請求書',
          priority: 1,
        },
        {
          id: 'CDKbx9n3NOWGohCowI038A',
          ap_report_form_input_option_master_id: 1004,
          value: '1004',
          display_value: '紙で受領した請求書',
          priority: 2,
        },
      ],
      input_values: [
        {
          id: 'upJF0NbJWM26tApSEMBfzw',
          value: '1003',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'MF0QySkZ4YmWUFqJ9RP1eA',
      label: '取引関係書類',
      type: 'ApReportFormInputBusinessDocumentsField',
      priority: 7,
      is_required: false,
      is_hidden: false,
      is_editable: false,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: 'UUybTANP4SbzokldLUJIrA',
          value: null,
        },
      ],
      input_additional_values: null,
    },
    {
      id: '9R6VsBnZrDmDBN3CPLPYeA',
      label: '支払期日',
      type: 'ApReportFormInputInvoiceDueDateField',
      priority: 8,
      is_required: true,
      is_hidden: false,
      is_editable: false,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: '4MMVftHsZY3BWT3-aNTxzw',
          value: '2024/11/11',
        },
      ],
      input_additional_values: null,
    },
    {
      id: '6RIKWrgVhQZ28JThMe_9NQ',
      label: '費用計上日',
      type: 'ApReportFormInputInvoiceBookDateField',
      priority: 9,
      is_required: true,
      is_hidden: false,
      is_editable: false,
      has_other_value: false,
      default_value: null,
      annotation: 'デフォルトは前月末日付となります',
      input_options: null,
      input_values: [
        {
          id: 'VufJ3vOpPGE5QtC5SqyKeQ',
          value: '2024/10/20',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'b4fTGfrwQGfPWhbDBzAykQ',
      label: '目的',
      type: 'ApReportFormInputTextArea',
      priority: 10,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: '',
      annotation: '目的を記載してください',
      input_options: null,
      input_values: [
        {
          id: 'fhM7R0JerLLCwk6LLpVZig',
          value: '',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'ah-kDYBhmKWjToOlhXuJAA',
      label: '申請番号',
      type: 'ApReportFormInputReportNumberForExpenseField',
      priority: 11,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: '',
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: 'kFPYQ7Q7dpI_TOSlPZpTWQ',
          value: '',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'SdYMtsqwfrLtq0xV-E8ezQ',
      label: '非表示項目',
      type: 'ApReportFormInputTextField',
      priority: 12,
      is_required: false,
      is_hidden: true,
      is_editable: true,
      has_other_value: false,
      default_value: '',
      annotation: '',
      input_options: null,
      input_values: null,
      input_additional_values: null,
    },
    {
      id: 'sBPvKhFm9HGUB0IZkXcXKw',
      label: '選択肢',
      type: 'ApReportFormInputCheckBox',
      priority: 13,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: true,
      default_value: '',
      annotation: '',
      input_options: [
        {
          id: 'GhhMsLm2MTGMcqCzkGdsoQ',
          ap_report_form_input_option_master_id: null,
          value: '11',
          display_value: '11',
          priority: 1,
        },
        {
          id: 'rmlBbYYDyVjYE3fCaREhtA',
          ap_report_form_input_option_master_id: null,
          value: '22',
          display_value: '22',
          priority: 1,
        },
        {
          id: 'Y-WQ-_zjGeoLhUHpO4NdyQ',
          ap_report_form_input_option_master_id: null,
          value: '33',
          display_value: '33',
          priority: 1,
        },
      ],
      input_values: [
        {
          id: 'WlgloIQLVAo54FzUS0brfQ',
          value: '',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'ks4_UunenAVKw1Vm_TKB6g',
      label: '数値',
      type: 'ApReportFormInputNumberField',
      priority: 14,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: '',
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: '9HQrOBvbWK9RCHEVZBsXvg',
          value: null,
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'ZQBWOnqUD19N25-UosNO_Q',
      label: '添付ファイル',
      type: 'ApReportFormInputFileField',
      priority: 15,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: 'inHLEh6vmXY62LVG6zCW9w',
          value: null,
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'iDvFkygkW_CaN7tx58JAmQ',
      label: '費用科目',
      type: 'ApReportFormInputProjectSelect',
      priority: 16,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: 'IEYzRcZn6MxWLYWX20sOeg',
          value: null,
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'FbnNuV6cpxl2AtyDY40aOA',
      label: '分岐条件利用',
      type: 'ApReportFormInputNumberFieldForBranch',
      priority: 17,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: '3',
      annotation: '分岐条件利用',
      input_options: null,
      input_values: [
        {
          id: 'NG2JwK_8t5O3UF3P2lOWlA',
          value: '3',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'AXpcaqHyUugrURIhGSFcAA',
      label: '日時',
      type: 'ApReportFormInputTimeField',
      priority: 18,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: null,
      annotation: '日付',
      input_options: null,
      input_values: [
        {
          id: 'l9ehnDl5MQJquvc0Ais9Vg',
          value: null,
        },
      ],
      input_additional_values: null,
    },
    {
      id: '1AIFNo2uFG6wq_ypgaihZg',
      label: 'OfficeMember',
      type: 'ApReportFormInputOfficeMemberSelect',
      priority: 19,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: 'OXVN3LxmzudJNkfzDvr7pw',
          value: null,
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'MJ5GxVToep0Qbas-OSqrIQ',
      label: '部門',
      type: 'ApReportFormInputDeptSelect',
      priority: 20,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: '0pHV7llhYTKczxWw_kiKqQ',
          value: null,
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'WHiaLkRiLQGw5F5b9g75QQ',
      label: 'pj',
      type: 'ApReportFormInputProjectSelect',
      priority: 21,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: '-uYRUElK5als5OSr6ZuCdQ',
          value: null,
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'Wb9wZt-QdZF-QDyqRiF1JQ',
      label: 'exItem',
      type: 'ApReportFormInputExItemSelect',
      priority: 22,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: 'SpH28M8VkYbZURQDxZaznA',
          value: null,
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'k7qISGQSFL0Kv-WkWGCu4g',
      label: 'aaa',
      type: 'ApReportFormInputSelect',
      priority: 23,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: true,
      default_value: '',
      annotation: '',
      input_options: [
        {
          id: 'r9rnJ6ZsDW_reYhcbJqXUg',
          ap_report_form_input_option_master_id: null,
          value: '1',
          display_value: '1',
          priority: 0,
        },
        {
          id: 'Ex5y6xzZLpbvGwbIYZs35g',
          ap_report_form_input_option_master_id: null,
          value: '2',
          display_value: '2',
          priority: 1,
        },
        {
          id: 'voJkxpzIqvUyay1rRjLmiA',
          ap_report_form_input_option_master_id: null,
          value: '3',
          display_value: '3',
          priority: 2,
        },
      ],
      input_values: [
        {
          id: 'COw84ZTr3whUYEQHgZNjYA',
          value: 'aiueo',
        },
      ],
      input_additional_values: null,
    },
    {
      id: '9Ygx3QBkyIALey3UrEWmhg',
      label: '事前申請番号',
      type: 'ApReportFormInputReportNumberForExpenseField',
      priority: 24,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: '',
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: 'aXN-rRTGQN1NEvgGYOtuOQ',
          value: '',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'GM8eoUcbAiAvSRjaRgrXqA',
      label: '契約番号',
      type: 'ApReportFormInputContractNumberField',
      priority: 25,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: '',
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: '4sIcv6_K1HIsrKoVgLCLLA',
          value: '',
        },
      ],
      input_additional_values: null,
    },
  ],
  invoice_file: {
    id: 'mock-invoice-file-id',
    name: '請求書_sample.pdf',
    byte_size: 50000,
    content_type: 'application/pdf',
    cache_content_url: '/invoices/sample.pdf',
    e_doc_meta_datum: {
      dpi_text: `${faker.number.int({ min: 30, max: 600 })} dpi`,
      pixel_number_text: `${faker.number.int({ min: 1, max: 50 })}万画素`,
      rgb_depth_text: `RGB(${faker.number.int({
        min: 100,
        max: 256,
      })}`,
      is_scan: true,
      is_satisfy_resolution_requirement: true,
      is_satisfy_depth_requirements: true,
    },
  },
  is_e_doc_ap_receipt_type_enabled: true,
});

export const getGetInvoiceTransactionsMock = () => ({
  invoice_transactions: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      ap_payee: faker.helpers.arrayElement([
        {
          id: faker.helpers.arrayElement([faker.word.sample()]),
          name: faker.helpers.arrayElement([faker.word.sample()]),
        },
      ]),
      ap_payee_type: faker.helpers.arrayElement([faker.word.sample()]),
      ap_report_id: faker.helpers.arrayElement([faker.word.sample()]),
      cr_item: faker.helpers.arrayElement([
        {
          id: faker.helpers.arrayElement([faker.word.sample()]),
          name: faker.helpers.arrayElement([faker.word.sample()]),
        },
      ]),
      cr_sub_item: faker.helpers.arrayElement([
        {
          id: faker.helpers.arrayElement([faker.word.sample()]),
          name: faker.helpers.arrayElement([faker.word.sample()]),
        },
      ]),
      currency: faker.helpers.arrayElement([faker.word.sample()]),
      deal_date: faker.helpers.arrayElement([
        faker.date
          .past({ refDate: FIXED_REF_DATE })
          .toISOString()
          .split('T')[0],
      ]),
      dept: faker.helpers.arrayElement([
        {
          id: faker.helpers.arrayElement([faker.word.sample()]),
          name: faker.helpers.arrayElement([faker.word.sample()]),
        },
      ]),
      dr_excise: faker.helpers.arrayElement([
        {
          id: faker.helpers.arrayElement([faker.word.sample()]),
          name: faker.helpers.arrayElement([faker.word.sample()]),
        },
      ]),
      ex_item: faker.helpers.arrayElement([
        {
          id: faker.helpers.arrayElement([faker.word.sample()]),
          name: faker.helpers.arrayElement([faker.word.sample()]),
        },
      ]),
      excise_value: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
      ]),
      has_withholding_income_tax: faker.helpers.arrayElement([
        faker.datatype.boolean(),
      ]),
      id: faker.helpers.arrayElement([faker.word.sample()]),
      invoice_kind: faker.helpers.arrayElement([faker.word.sample()]),
      jpyrate: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
      ]),
      memo: faker.helpers.arrayElement([faker.word.sample()]),
      name: faker.helpers.arrayElement([faker.word.sample()]),
      number: faker.helpers.arrayElement([faker.word.sample()]),
      project_code: faker.helpers.arrayElement([
        {
          id: faker.helpers.arrayElement([faker.word.sample()]),
          name: faker.helpers.arrayElement([faker.word.sample()]),
        },
      ]),
      quantity: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
      ]),
      total_value: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
      ]),
      unit_value: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
      ]),
      use_custom_jpy_rate: faker.helpers.arrayElement([
        faker.datatype.boolean(),
      ]),
      withholding_income_tax_value: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
      ]),
    })),
  ]),
});

export const getSearchInvoiceReportsMock = () => ({
  invoice_reports: Array.from({ length: 25 }, () => ({
    ap_payee_name: '株式会社テストクリエイティブソリューションズ',
    approved_at: '2025-04-30T00:00:00Z',
    book_date: '2025-04-30',
    created_at: '2025-04-30T00:00:00Z',
    detail_path: '/invoice_reports/AP1234',
    due_date: '2025-04-30',
    edit_path: '/invoice_reports/AP1234/edit',
    payment_date: '2025-05-15',
    payment_status: faker.helpers.arrayElement(['not_yet_paid', 'paid', null]),
    id: `AP${faker.number.int({ min: 1000, max: 9999 })}`,
    invoice_file: {
      byte_size: 1024,
      cache_content_url: '#',
      can_delete: false,
      content_type: 'application/pdf',
      id: 'file-1234',
      receipt_type: '電子取引',
      filename:
        'WPDW0000001_multiple_excise + multiple item_20250811111806.pdf',
    },
    is_cancelable: faker.datatype.boolean(),
    is_copyable: faker.datatype.boolean(),
    is_deletable: faker.datatype.boolean(),
    is_editable: faker.datatype.boolean(),
    copy_path: '/invoice_reports/AP1234/copy',
    delete_action: { visible: true, allowed: true, reason: null },
    edit_action: { visible: true, allowed: true, reason: null },
    cancel_action: { visible: false, allowed: false, reason: null },
    number: `AP${faker.number.int({ min: 1000, max: 9999 })}`,
    office_member: {
      display_name: '田中一二三',
      id: '100',
      name: '田中一二三',
      number: '100',
    },
    report_approval_names: '佐藤次郎,高橋敏徳,鈴木拓,山田太郎',
    status: (() => {
      const statusMap = [
        { key: 'unsubmitted', display_name: '下書き' },
        { key: 'approved', display_name: '承認済み' },
        { key: 'rejected', display_name: '差戻し' },
        { key: 'canceled', display_name: '取消し' },
        { key: 'unsubmitted', display_name: '未申請' },
        { key: 'waiting_step_one', display_name: '第一承認待ち' },
        { key: 'waiting_step_two', display_name: '第二承認待ち' },
      ];
      return statusMap[Math.floor(Math.random() * statusMap.length)];
    })(),
    submitted_at: '2025-04-30T00:00:00Z',
    title: '2025年5月支払依頼 - 詳細な説明と追加の情報を含む長いタイトル',
    total_amount: '100,000',
    foreign_currency_amount: '(100,000)',
    automatic_status_waiting: faker.helpers.arrayElement([
      'before_flair_upload',
      'flair_uploaded',
      'before_streamed_upload',
      'streamed_uploaded',
      'before_ocr_upload',
      'ocr_uploaded',
      undefined,
    ]),
    timestamp_status_creating: faker.helpers.arrayElement([
      'creating',
      undefined,
    ]),
    error_messages: [
      {
        message_type: 'duplicate_reports_message',
        type: 'warn',
        label: '類似申請',
        message:
          '類似の支払依頼が申請されています。申請番号：AP90000（佐藤次郎）',
      },
    ],
    cannot_cancel_reason: null,
  })),
  pagination: {
    has_next_page: true,
    has_previous_page: false,
    page: 1,
    per_page: 25,
    total_pages: 10,
    total_records: 250,
  },
});

export const getGetTargetApplicantsForInvoiceReportsMock = () => ({
  next: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
  ]),
  office_members: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      display_name: faker.helpers.arrayElement([faker.word.sample()]),
      id: faker.helpers.arrayElement([faker.word.sample()]),
      name: faker.helpers.arrayElement([faker.word.sample()]),
      number: faker.helpers.arrayElement([faker.word.sample()]),
    })),
  ]),
  prev: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
  ]),
});

export const getGetInvoiceReportSummaryMock = () => ({
  agent_applicant_office_member_name: faker.helpers.arrayElement([
    faker.word.sample(),
    undefined,
  ]),
  approved_at: faker.helpers.arrayElement([
    `${
      faker.date.past({ refDate: FIXED_REF_DATE }).toISOString().split('.')[0]
    }Z`,
    undefined,
  ]),
  created_at: `${
    faker.date.past({ refDate: FIXED_REF_DATE }).toISOString().split('.')[0]
  }Z`,
  foreign_currency_amount: faker.helpers.arrayElement([
    faker.word.sample(),
    undefined,
  ]),
  id: faker.word.sample(),
  number: faker.word.sample(),
  office_member: {
    display_name: faker.person.fullName(),
    id: faker.word.sample(),
    name: faker.person.fullName(),
  },
  report_dept: faker.helpers.arrayElement([
    { id: faker.word.sample(), name: faker.word.sample() },
    undefined,
  ]),
  status: faker.helpers.arrayElement(Object.values(ApReportStatus)),
  submitted_at: faker.helpers.arrayElement([
    `${
      faker.date.past({ refDate: FIXED_REF_DATE }).toISOString().split('.')[0]
    }Z`,
    undefined,
  ]),
  tax_rate_items: Array.from(
    { length: faker.number.int({ min: 1, max: 3 }) },
    () => ({
      excise_values: faker.word.sample(),
      subtotal: faker.word.sample(),
      subtotal_with_tax: faker.word.sample(),
      tax_rate: faker.word.sample(),
    })
  ),
  title: faker.word.sample(),
  total_excise_value: faker.word.sample(),
  total_transaction_details_value: faker.word.sample(),
  total_value: faker.word.sample(),
  total_withholding_income_tax_value: faker.word.sample(),
});

export const getGetInvoiceReportPaymentInfoMock = () => {
  const files = faker.helpers.arrayElement([
    `請求書${faker.number.int({ min: 1, max: 2 })}.pdf`,
    'image.jpg',
  ]);

  return {
    report_form_inputs: [
      {
        id: 'F8y3sxbxPakNTZHpB9ibTA',
        label: '支払先種別',
        type: 'ApReportFormInputInvoicePayeeType',
        input_values: [
          { id: '6UYJDFR12P08Vvrv4T9O0w', label: '1005', value: '1005' },
        ],
        input_additional_values: null,
      },
      {
        id: 'rZ96tF6EzgWsxA6g_wPxfA',
        label: '支払先',
        type: 'ApReportFormInputInvoicePayeeSelect',
        input_values: [
          {
            id: 'MYstWd5p4OzuZPbOHcf9eA',
            label: 'Tom Nguyen（133222112）（銀行口座振込）',
            value: 'i0LAkK8hbNPbRL5C9I5vew',
          },
        ],
        input_additional_values: null,
      },
      {
        id: 'ktPMUL5PTrSAqBAwTwK1LQ',
        label: '適格請求書発行事業者登録番号',
        type: 'ApReportFormInputInvoiceRegistrationNumberField',
        input_values: [
          {
            id: '6r9rWgVfeIXf5VapzmuBjw',
            label: 'T2332222322232',
            value: '1234567891234',
          },
        ],
        input_additional_values: [{ is_mismatched: false }],
      },
      {
        id: 'lDSxz4n4tNmyoHX4r3CigA',
        label: '請求書画像',
        type: 'ApReportFormInputInvoiceFileField',
        input_values: [
          {
            id: 'HDtz9a8wca8OZfnxCLCdOQ',
            label:
              '\u003ca href="/mf_files/JRv8nGG-cDMPBxlMQcCXLQ"\u003emultiple_page.pdf\u003c/a\u003e',
            value: 'JRv8nGG-cDMPBxlMQcCXLQ',
          },
        ],
        input_additional_values: [
          {
            id: files,
            cache_content_url: '/mf_files/JRv8nGG-cDMPBxlMQcCXLQ',
            can_delete: false,
            byte_size: 98538,
            content_type: 'application/pdf',
            name: 'multiple_page.pdf',
            e_doc_meta_datum: {
              is_scan: faker.datatype.boolean(),
              is_satisfy_resolution_requirement: faker.helpers.arrayElement([
                faker.datatype.boolean(),
              ]),
              is_satisfy_depth_requirements: faker.helpers.arrayElement([
                faker.datatype.boolean(),
              ]),
              dpi_text: `${faker.number.int({ min: 30, max: 600 })} dpi`,
              pixel_number_text: `${faker.number.int({
                min: 1,
                max: 50,
              })}万画素`,
              width_and_height_pixel_text: `${faker.number.int({
                min: 800,
                max: 4000,
              })} * ${faker.number.int({ min: 600, max: 3000 })}`,
              rgb_depth_text: `RGB(${faker.number.int({
                min: 100,
                max: 256,
              })}, ${faker.number.int({
                min: 100,
                max: 256,
              })}, ${faker.number.int({ min: 100, max: 256 })})`,
            },
            invoice_number: 'IV-4',
            receipt_type: 'paper',
            timestamp_status: 'done',
          },
        ],
      },
      {
        id: 'g8luUEVnEm5ptVEADhJ4EQ',
        label: '取引関係書類',
        type: 'ApReportFormInputBusinessDocumentsField',
        input_values: [
          {
            id: 'ktPMUL5PTrSAqBAwTwK1LQ',
            label:
              'Doc-4：multiple_page.pdf,Doc-3：multiple_excise + multiple item.pdf,Doc-2：multiple_page.pdf,Doc-1：invoice.jpg',
            value:
              'cqOAYGirucwN-IWVnLuRaw,N5yLO_aNpvuekQdvLI_ptA,i0LAkK8hbNPbRL5C9I5vew,wXsJZNcoaRpfVBRhdlGMFQ',
          },
        ],
        input_additional_values: [
          {
            id: 'wXsJZNcoaRpfVBRhdlGMFQ',
            document_title: 'multiple_page.pdf',
            document_number: 'Doc-4',
            document_type: 'purchase_order',
            mf_file: {
              id: 'xpbcR-YP_n639KdLslY-SQ',
              cache_content_url: '/mf_files/JRv8nGG-cDMPBxlMQcCXLQ',
              can_delete: false,
              byte_size: 107884,
              content_type: 'application/pdf',
              name: 'multiple_page_20250829124128.pdf',
              timestamp_status: 'done',
              e_doc_meta_datum: {
                is_scan: faker.datatype.boolean(),
                is_satisfy_resolution_requirement: faker.helpers.arrayElement([
                  faker.datatype.boolean(),
                ]),
                is_satisfy_depth_requirements: faker.helpers.arrayElement([
                  faker.datatype.boolean(),
                ]),
                dpi_text: `${faker.number.int({ min: 30, max: 600 })} dpi`,
                pixel_number_text: `${faker.number.int({
                  min: 1,
                  max: 50,
                })}万画素`,
                width_and_height_pixel_text: `${faker.number.int({
                  min: 800,
                  max: 4000,
                })} * ${faker.number.int({ min: 600, max: 3000 })}`,
                rgb_depth_text: `RGB(${faker.number.int({
                  min: 100,
                  max: 256,
                })}, ${faker.number.int({
                  min: 100,
                  max: 256,
                })}, ${faker.number.int({ min: 100, max: 256 })})`,
              },
              receipt_type: 'paper',
            },
          },
          {
            id: 'i0LAkK8hbNPbRL5C9I5vew',
            document_title: 'multiple_excise + multiple item.pdf',
            document_number: 'Doc-3',
            document_type: 'receipt',
            mf_file: {
              id: files,
              cache_content_url: '/mf_files/aMtZ0ldoqeJE7uTLFwyYLA',
              can_delete: false,
              byte_size: 400063,
              content_type: 'application/pdf',
              name: 'multiple_excise + multiple item_20250821194136.pdf',
            },
          },
          {
            id: 'N5yLO_aNpvuekQdvLI_ptA',
            document_title: 'multiple_page.pdf',
            document_number: 'Doc-2',
            document_type: 'contract',
            mf_file: {
              id: files,
              cache_content_url: '/mf_files/qZgtHZRBa7RQKW1wQ_Ii4g',
              can_delete: false,
              byte_size: 107884,
              content_type: 'application/pdf',
              name: 'multiple_page_20250821194106.pdf',
            },
          },
          {
            id: 'cqOAYGirucwN-IWVnLuRaw',
            document_title: 'invoice.jpg',
            document_number: 'Doc-1',
            document_type: 'not_specified',
            mf_file: {
              id: '69EnOKOHg0ojZMWwXxOwmg',
              cache_content_url: '/mf_files/69EnOKOHg0ojZMWwXxOwmg',
              can_delete: false,
              byte_size: 1081319,
              content_type: 'application/pdf',
              name: 'invoice_20250821194046.pdf',
            },
          },
        ],
      },
      {
        id: 'r-ka4_b_SlIMFd0JUPnmsg',
        label: '請求書受領区分',
        type: 'ApReportFormInputReceiptType',
        input_values: [
          {
            id: 'aVB6OHEi1hOG09giqF0v8A',
            label: '電子 (PDF,JPEG等) で受領した請求書',
            value: '1003',
          },
        ],
        input_additional_values: null,
      },
      {
        id: 'D5BNUhWSzgsrrXBkv3FlFQ',
        label: '費用計上日',
        type: 'ApReportFormInputInvoiceBookDateField',
        input_values: [
          {
            id: 'lDSxz4n4tNmyoHX4r3CigA',
            label: '2025/07/31',
            value: '2025/07/31',
          },
        ],
        input_additional_values: null,
      },
      {
        id: 'mqEI85YxjHAzGUHB4wdspQ',
        label: '支払期日',
        type: 'ApReportFormInputInvoiceDueDateField',
        input_values: [
          {
            id: 'D5BNUhWSzgsrrXBkv3FlFQ',
            label: '2025/08/29',
            value: '2025/08/29',
          },
        ],
        input_additional_values: null,
      },
      {
        id: 'xxYx9lMixO0VldIZrJHZqw',
        label: '目的',
        type: 'ApReportFormInputTextArea',
        input_values: [
          {
            id: 'mqEI85YxjHAzGUHB4wdspQ',
            label: 'note nha',
            value: 'note nha',
          },
        ],
        input_additional_values: null,
      },
      {
        id: 'encrypted_report_field_id_456',
        label: '事前申請番号',
        type: 'ApReportFormInputReportNumberForExpenseField',
        input_values: [
          {
            id: 'encrypted_report_value_id_0',
            label: 'AP001',
            value: 'https://ap.example.com/reports/AP001',
          },
          {
            id: 'encrypted_report_value_id_1',
            label: '002',
            value: 'https://ex.example.com/reports/002',
          },
          {
            id: 'encrypted_report_value_id_2',
            label: 'EXTERNAL123',
            value: null,
          },
        ],
        input_additional_values: null,
      },
      {
        id: 'FHmMaubNTUxGZSKRDbLhSA',
        label: 'sample 1',
        type: 'ApReportFormInputCheckBox',
        input_values: [
          { id: 'QgJzzSFkAq_8L7-xvidTEw', label: 'choice1', value: 'choice1' },
        ],
        input_additional_values: null,
      },
      {
        id: 'bQNwTp7SDTA3-bEJNBgkrg',
        label: 'sadasd',
        type: 'ApReportFormInputFileField',
        input_values: [
          {
            id: 'BzuyVCKrzewyK3oV3m3Blw',
            label:
              '\u003ca href="/mf_files/zlbSVn2PuxZygLY8ZQ7MCg"\u003emultiple_page.pdf\u003c/a\u003e',
            value: 'zlbSVn2PuxZygLY8ZQ7MCg',
          },
        ],
        input_additional_values: [
          {
            id: 'zlbSVn2PuxZygLY8ZQ7MCg',
            cache_content_url: '/mf_files/zlbSVn2PuxZygLY8ZQ7MCg',
            can_delete: true,
            byte_size: 98538,
            content_type: 'application/pdf',
            name: 'multiple_page.pdf',
          },
        ],
      },
      {
        id: 'encrypted_contract_field_id_123',
        label: '契約番号',
        type: 'ApReportFormInputContractNumberField',
        input_values: [
          {
            id: 'encrypted_contract_value_id_0',
            label: 'CONTRACT001',
            value: 'https://stampless.example.com/contracts/CONTRACT001',
          },
          {
            id: 'encrypted_contract_value_id_1',
            label: 'CONTRACT002',
            value: null,
          },
        ],
        input_additional_values: null,
      },
      {
        id: 'a7-kutHUeRqpw_l0AKAJmg',
        label: 'radio button',
        type: 'ApReportFormInputRadioButton',
        input_values: null,
        input_additional_values: null,
      },
      {
        id: '__SRX5Ii-yyZDcBztkMWPg',
        label: 'dropdown',
        type: 'ApReportFormInputSelect',
        input_values: [
          { id: 's6FP_UpqBOmZygQ02REuJw', label: 'dd1', value: 'dd1' },
        ],
        input_additional_values: null,
      },
    ],
  };
};

export const getGetInvoiceReportBusinessDocumentMock = () => ({
  id: faker.string.uuid(),
  searchable_number: faker.number.int({ min: 100000, max: 999999 }),
  document_title: faker.company.name() + ' 契約書',
  document_type: 'contract',
  filename: 'contract_document.pdf',
  counterparty_name: faker.company.name(),
  transaction_date: faker.date
    .recent({ refDate: FIXED_REF_DATE })
    .toISOString()
    .split('T')[0],
  amount: faker.number.int({ min: 10000, max: 1000000 }),
  memo: faker.lorem.sentence(),
  receipt_type: faker.helpers.arrayElement(['e_doc', 'paper']),
  timestamp_status: faker.helpers.arrayElement([
    'done',
    'creating',
    'unsupported',
    'failed',
  ]),
  automatic_status: faker.helpers.arrayElement(['ocr_done', 'ocr_skipped']),
  pics: [
    {
      id: faker.string.uuid(),
      display_name: faker.person.fullName(),
      name: faker.person.fullName(),
    },
  ],
  uploader: {
    id: faker.string.uuid(),
    display_name: faker.person.fullName(),
    name: faker.person.fullName(),
  },
  uploaded_at: faker.date.recent({ refDate: FIXED_REF_DATE }).toISOString(),
  archived: false,
  upload_type: 'manual',
  mf_file: {
    id: faker.string.uuid(),
    name: 'contract_document.pdf',
    byte_size: faker.number.int({ min: 10000, max: 5000000 }),
    content_type: 'application/pdf',
    cache_content_url: 'https://example.com/mock-pdf.pdf',
  },
  e_doc_meta_datum: {
    dpi_text: '300dpi',
    pixel_number_text: `${faker.number.int({ min: 1, max: 50 })}万画素`,
    width_and_height_pixel_text: `${faker.number.int({
      min: 800,
      max: 4000,
    })} * ${faker.number.int({ min: 600, max: 3000 })}`,
    rgb_depth_text: '24bit',
    is_scan: true,
    is_satisfy_resolution_requirement: true,
    is_satisfy_depth_requirements: true,
  },
});

export const getGetInvoiceReportPaymentStatusesMock = () => [
  {
    display_name: '未払い',
    value: 'not_yet_paid',
  },
  {
    display_name: '支払い済み',
    value: 'paid',
  },
];

/**
 * Mock journal for `GET /api/js/invoice_reports/:id/journal` (`useGetInvoiceReportJournalSuspense`).
 * Standalone from approving mocks.
 */
export const getGetInvoiceReportJournalMock = () => ({
  entries: [
    {
      dr_item_name: '支払手数料',
      dr_sub_item_name: '振込料',
      dr_dept_name: '経理部',
      dr_project_code_name: 'PRJ-2024-001',
      dr_counterparty_name: '株式会社サンプル取引先',
      dr_invoice_kind: '適格',
      dr_display_amount: '¥1,100',
      dr_excise_name: '課税売上10%',
      dr_display_purchase_tax_credit: '¥100',
      cr_item_name: '普通預金',
      cr_sub_item_name: '三菱UFJ 本店',
      cr_dept_name: '経理部',
      cr_project_code_name: 'PRJ-2024-001',
      cr_counterparty_name: '株式会社サンプル取引先',
      cr_invoice_kind: '適格',
      cr_display_amount: '¥1,100',
      cr_excise_name: '課税売上10%',
      cr_display_purchase_tax_credit: '¥100',
    },
    {
      dr_item_name: '通信費',
      dr_sub_item_name: 'インターネット回線',
      dr_dept_name: '総務部',
      dr_project_code_name: '',
      dr_counterparty_name: 'テレコム株式会社',
      dr_invoice_kind: '80%控除',
      dr_display_amount: '¥5,500',
      dr_excise_name: '課税売上10%',
      dr_display_purchase_tax_credit: '¥500',
      cr_item_name: '未払金',
      cr_sub_item_name: '',
      cr_dept_name: '総務部',
      cr_project_code_name: '',
      cr_counterparty_name: 'テレコム株式会社',
      cr_invoice_kind: '80%控除',
      cr_display_amount: '¥5,500',
      cr_excise_name: '課税売上10%',
      cr_display_purchase_tax_credit: '¥500',
    },
    {
      dr_item_name: '消耗品費',
      dr_sub_item_name: '事務用品',
      dr_dept_name: '営業第一部',
      dr_project_code_name: 'PRJ-2024-088',
      dr_counterparty_name: '文房具センター',
      dr_invoice_kind: '非適格',
      dr_display_amount: '¥3,300',
      dr_excise_name: '非課税',
      dr_display_purchase_tax_credit: '—',
      cr_item_name: '小口現金',
      cr_sub_item_name: '',
      cr_dept_name: '営業第一部',
      cr_project_code_name: 'PRJ-2024-088',
      cr_counterparty_name: '文房具センター',
      cr_invoice_kind: '非適格',
      cr_display_amount: '¥3,300',
      cr_excise_name: '非課税',
      cr_display_purchase_tax_credit: '—',
    },
    ...Array.from({ length: faker.number.int({ min: 0, max: 2 }) }, (_, i) => ({
      dr_item_name: `雑費（動的${i + 1}）`,
      dr_sub_item_name: '',
      dr_dept_name: faker.company.name(),
      dr_project_code_name: '',
      dr_counterparty_name: faker.company.name(),
      dr_invoice_kind: '対象外',
      dr_display_amount: `¥${faker.number
        .int({ min: 100, max: 99999 })
        .toLocaleString()}`,
      dr_excise_name: '課税売上8%',
      dr_display_purchase_tax_credit: '¥0',
      cr_item_name: '当座預金',
      cr_sub_item_name: '',
      cr_dept_name: faker.company.name(),
      cr_project_code_name: '',
      cr_counterparty_name: faker.company.name(),
      cr_invoice_kind: '対象外',
      cr_display_amount: `¥${faker.number
        .int({ min: 100, max: 99999 })
        .toLocaleString()}`,
      cr_excise_name: '課税売上8%',
      cr_display_purchase_tax_credit: '¥0',
    })),
  ],
  entry_fields: [
    'dr_item_name',
    'dr_sub_item_name',
    'dr_dept_name',
    'dr_project_code_name',
    'dr_counterparty_name',
    'dr_invoice_kind',
    'dr_display_amount',
    'cr_item_name',
    'cr_sub_item_name',
    'cr_dept_name',
    'cr_project_code_name',
    'cr_counterparty_name',
    'cr_invoice_kind',
    'cr_display_amount',
    'dr_excise_name',
    'cr_excise_name',
    'dr_display_purchase_tax_credit',
    'cr_display_purchase_tax_credit',
  ],
});

export const handlers = [
  http.post('*/api/js/invoice_reports/search', async () => {
    await delay(1000);
    return new HttpResponse(JSON.stringify(getSearchInvoiceReportsMock()), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }),
  http.get('*/api/js/invoice_reports/payment_statuses', async () => {
    await delay(1000);
    return new HttpResponse(
      JSON.stringify(getGetInvoiceReportPaymentStatusesMock()),
      {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }),
  http.get('*/api/js/invoice_reports/:id/report_summary', async () => {
    await delay(1000);
    return new HttpResponse(JSON.stringify(getGetInvoiceReportSummaryMock()), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }),
  http.get('*/api/js/invoice_reports/:id/payment_info', async () => {
    await delay(1000);
    return new HttpResponse(
      JSON.stringify(getGetInvoiceReportPaymentInfoMock()),
      {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }),
  http.get('*/api/js/invoice_reports/:id/journal', async () => {
    await delay(1000);
    return new HttpResponse(JSON.stringify(getGetInvoiceReportJournalMock()), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }),
  http.get('*/api/js/invoice_reports/business_documents/:id', async () => {
    await delay(1000);
    return new HttpResponse(
      JSON.stringify(getGetInvoiceReportBusinessDocumentMock()),
      {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }),
  http.get('*/api/js/invoice_reports/:id', async () => {
    await delay(1000);
    return new HttpResponse(JSON.stringify(getGetInvoiceReportsMock()), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }),
  http.get('*/api/js/invoice_reports/:id/invoice_transactions', async () => {
    await delay(1000);
    return new HttpResponse(JSON.stringify(getGetInvoiceTransactionsMock()), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }),
  http.get('*/api/js/agent_applicant_target_office_members', async () => {
    await delay(1000);
    return new HttpResponse(
      JSON.stringify(getGetTargetApplicantsForInvoiceReportsMock()),
      {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }),
];
